import user from './user'
import notifications from './notifications'
import subscribers from './subscribers'
import config from './config'
import preferences from './preferences'

import { SET_TOKEN, LOGOUT } from '../constants/actions'

export default {
    subscribers,
    calls: (state = [], action) => action.type == 'SET_CALLS' ? action.calls : state,
    user,
    config,
    preferences,
    notifications,
    token: (state = false, action) => {
        if (action.type === SET_TOKEN) return action.token
        if (action.type === LOGOUT) return false
        return state
    }
}



// WEBPACK FOOTER //
// ./reducers/index.js